import { render, staticRenderFns } from "./EditEvent.vue?vue&type=template&id=35306b36&"
import script from "./EditEvent.vue?vue&type=script&lang=js&"
export * from "./EditEvent.vue?vue&type=script&lang=js&"
import style0 from "./EditEvent.vue?vue&type=style&index=0&id=35306b36&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports